import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mirror_right",
  "use": "icon-mirror_right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-mirror_right\"><path d=\"M860.16 293.888a38.4 38.4 0 0 1-2.048 54.272l-443.008 410.752L163.2 473.408a38.4 38.4 0 1 1 57.6-50.816l199.808 226.496 385.28-357.248a38.4 38.4 0 0 1 54.272 2.048z\" p-id=\"5235\" fill=\"#2bbf57\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol